import {
  ChangeDetectorRef, Component, Input, OnDestroy, OnInit, TemplateRef
} from '@angular/core';
import { Subscription } from "rxjs";
import {MatDrawerMode, MatSidenavModule} from "@angular/material/sidenav";
import { ActivatedRoute } from "@angular/router";
import {NavigationRouteItem, NavigationStateService} from "../../services/navigation-state.service";
import {ScreenSize, ScreenSizeService} from "../../services/screen-size.service";
import {JsonPipe, NgClass, NgIf} from "@angular/common";
import {LayoutContentHeaderComponent} from "../layout-content-header/layout-content-header.component";
import {RouteContainerComponent} from "../route-container/route-container.component";


@Component({
  selector: 'layout-master',
  templateUrl: './layout-master.component.html',
  styleUrls: ['./layout-master.component.sass'],
  imports: [
    MatSidenavModule,
    NgClass,
    LayoutContentHeaderComponent,
    RouteContainerComponent,
    NgIf,
    JsonPipe
  ],
  standalone: true
})
export class LayoutMasterComponent implements OnInit, OnDestroy {

  @Input() headerButtonsTemplate?: TemplateRef<any>
  @Input() lastNavigationItemTemplate?: TemplateRef<{
    navigationItem?: NavigationRouteItem,
    debug?: boolean
  }>

  breadcrumbs: NavigationRouteItem[] = []
  breadcrumbsSubscription?: Subscription

  get currentNavigationRouteItem(): NavigationRouteItem | undefined {
    if (this.breadcrumbs.length) {
      return this.breadcrumbs[this.breadcrumbs.length - 1]
    }
    return undefined
  }

  get currentNavigationRouteItemNgClass() {
    if (this.currentNavigationRouteItem?.data && 'contentNgClass' in this.currentNavigationRouteItem.data) {
      return this.currentNavigationRouteItem.data['contentNgClass']
    }
    return 'ms-2 me-2'
  }

  sideNavOpen: boolean = true
  screenSizeSubscription?: Subscription
  screenSize: ScreenSize
  activeRouterOutletEvent: any

  get isChildActive(): boolean {
    return this.activeRouterOutletEvent != undefined
  }

  get sideNavMode(): MatDrawerMode {
    if (this.screenSize == 'xs' || this.screenSize == 'sm') {
      return 'side'
    }
    return 'side'
  }

  constructor(
    protected readonly cdr: ChangeDetectorRef,
    protected readonly screenSizeService: ScreenSizeService,
    protected readonly navState: NavigationStateService,
    protected activatedRoute: ActivatedRoute,
  ) {
    this.screenSize = this.screenSizeService.screenSize
  }

  ngOnInit(): void {
    this.screenSizeService.invalidate()
    this.screenSizeSubscription = this.screenSizeService.screenSizeChange.subscribe({
      next: (sz) => { this.screenSize = sz}
    })
    this.activatedRoute.url.subscribe(x => {
      this.breadcrumbs = this.navState.buildBreadcrumbsForRoute(this.activatedRoute.snapshot)
    })
    this.breadcrumbsSubscription = this.navState.breadcrumbsChange.subscribe(br => {
      this.breadcrumbs = br
    })
  }

  ngOnDestroy(): void {
    this.screenSizeSubscription?.unsubscribe()
    this.screenSizeSubscription = undefined
    this.breadcrumbsSubscription?.unsubscribe()
    this.breadcrumbsSubscription = undefined
    this.navState.unsubscribe()
  }

  onRouterContainerChange(ev: { activated: boolean, eventArgs: any}) {
    this.activeRouterOutletEvent = ev.eventArgs
    this.cdr.detectChanges();
  }
}
